import { useApp } from "@/hooks/use-app-context";
import { useAdminScope } from "@/hooks/use-admin-scope";
import { Icon } from "@/lib/icons";

/**
 * What the admin space tells the administrator about the languages they may
 * read.
 *
 * Without it, an administrator whose scope holds no language sees empty
 * lists and empty filters, with no sign of the reason. A scope that could
 * not be read looked exactly the same.
 */
export function AdminScopeNotice() {
  const { t } = useApp();
  const { scopeState, refetchScope } = useAdminScope();
  const copy = t.admin.scopeNotice;

  if (scopeState === "ready") return null;

  if (scopeState === "loading") {
    return (
      <p
        data-testid="admin-scope-loading"
        className="flex items-center gap-2 rounded-2xl border border-border/40 bg-muted/20 px-5 py-4 text-sm text-muted-foreground"
      >
        <Icon name="loader2" className="h-4 w-4 animate-spin" />
        {copy.loading}
      </p>
    );
  }

  if (scopeState === "error") {
    return (
      <p
        data-testid="admin-scope-error"
        className="flex flex-wrap items-center gap-3 rounded-2xl border border-destructive/30 bg-destructive/5 px-5 py-4 text-sm text-destructive"
      >
        {copy.error}
        <button
          type="button"
          onClick={() => void refetchScope()}
          className="font-semibold underline"
        >
          {copy.retry}
        </button>
      </p>
    );
  }

  return (
    <p
      data-testid="admin-scope-empty"
      className="rounded-2xl border border-border/40 bg-muted/20 px-5 py-4 text-sm text-muted-foreground"
    >
      {t.admin.dashboard.noLanguageAssigned}
    </p>
  );
}
